import React, { useContext, useState, 
  // useRef
} from "react";
import DashboardContext from "../../../contexts/DashboardContext";
import Loading from "../../Shared/ResourceIndex/Loading";
// import _ from 'lodash';
import SideFilterMenu from "../shared/SideFilterMenu/SideFilterMenu";
import ProjectsChartWidget from "../shared/ChartWidget/ProjectsChartWidget/ProjectsChartWidget";
import OverdueFindingsChartWidget from "../shared/ChartWidget/OverdueFindingsChartWidget/OverdueFindingsChartWidget";
import MissedInspectionsChartWidget from "../shared/ChartWidget/MissedInspectionsChartWidget/MissedInspectionsChartWidget";

const Regions = (props) => {
  const { setTabIndex, setDashboardTabIndex } = props
  const { regionsTabList, isLoadingRegionsTab } = useContext(DashboardContext)
  const [ selectedOverdueThreshold, setSelectedOverdueThreshold ] = useState(7)
  const [ selectedRegionValue, setSelectedRegionValue ] = useState("All Regions");
  // const searchRef = useRef(null);
  // const { setqueryParamsForRegionsTab, queryParamsForRegionsTab } = useContext(DashboardContext)

  let totalCounts = 0

  // const handleSearchFunc = _.debounce((event) => {
  //   setqueryParamsForRegionsTab({...queryParamsForRegionsTab, s: event.target.value})
  // }, 500);

  const allRegionsCummulativeCounts = () => {
    const allRegionsData = regionsTabList && regionsTabList.reduce((acc, ele) => {
      acc.allRegionsTotalProjectsCount += ele.totalProjectsCount
      acc.allRegionsTotalInspectionsCount += ele.totalInspectionsCount
      acc.allRegionsMissedInspectionsCount += ele.missedInspectionsCount
      acc.allRegionsTotalFindingsCount += ele.totalFindingsCount
      acc.allRegionsOverdueFindingsCount += ele.overdueFindingsCount

      return acc
      },
      { 
        allRegionsName: "All Regions",
        allRegionsTotalProjectsCount: 0,
        allRegionsTotalInspectionsCount: 0,
        allRegionsMissedInspectionsCount: 0,
        allRegionsTotalFindingsCount: 0,
        allRegionsOverdueFindingsCount: 0
      }
    )

    totalCounts = allRegionsData
    const { allRegionsName, allRegionsTotalProjectsCount, allRegionsTotalInspectionsCount, allRegionsMissedInspectionsCount, allRegionsTotalFindingsCount, allRegionsOverdueFindingsCount } = allRegionsData

    return(
      <div className="regions__table-body">
        <li>{allRegionsName}</li>
        <li>{allRegionsTotalProjectsCount}</li>
        <li>{allRegionsTotalInspectionsCount}</li>
        <li>{allRegionsMissedInspectionsCount}</li>
        <li>{allRegionsTotalFindingsCount}</li>
        <li>{allRegionsOverdueFindingsCount}</li>
        <li><span onClick={() => {
          setTabIndex(2)
          localStorage.setItem('dashboardTabLastSelected', 2)
          setDashboardTabIndex(2)
        }}>View Divisions</span></li>
      </div>
    )
  }

  return (
    <div className="regions__outer-outer-wrapper">
      <SideFilterMenu tabName={'Regions'} setSelectedOverdueThreshold={setSelectedOverdueThreshold} setSelectedRegionValue={setSelectedRegionValue} />
      
      <div className="regions__outer-wrapper">      
        <div className="regions">
          {/* <input className="regions__search-bar" ref={searchRef} onChange={(event) => handleSearchFunc(event)} placeholder="Search" /> */}

          <div className="regions__content">
            <div className="regions__table-head">
              <h3>Region </h3>
              <h3>Total Projects </h3>
              <h3>Total Inspections </h3>
              <h3>Missed Inspections </h3>
              <h3>Total Findings </h3>
              <h3>Overdue Findings </h3>
              <h3>Action </h3>
            </div>

            {
              !isLoadingRegionsTab ?
              (
                <>
                  {allRegionsCummulativeCounts()}
                  {regionsTabList && regionsTabList.map((ele, index) => {
                    return (
                      <div key={index} className="regions__table-body">
                        <li>{ele.regionName}</li>
                        <li>{ele.totalProjectsCount}</li>
                        <li>{ele.totalInspectionsCount}</li>
                        <li>{ele.missedInspectionsCount}</li>
                        <li>{ele.totalFindingsCount}</li>
                        <li>{ele.overdueFindingsCount}</li>
                        <li><span onClick={() => {
                          setTabIndex(2)
                          localStorage.setItem('dashboardTabLastSelected', 2)
                          setDashboardTabIndex(2)
                        }}>View Divisions</span></li>
                      </div>
                    )
                  })}
                </>
              ) :
              (<Loading what="data" />)
            }
          </div>
        </div>
      </div>

      <div className="regions__charts">
        <ProjectsChartWidget data={regionsTabList} nameKey="regionName" dataKey="totalProjectsCount" headerTotalCount={totalCounts && totalCounts.allRegionsTotalProjectsCount} selectedRegionValue={selectedRegionValue}/>
        <MissedInspectionsChartWidget totalCounts={totalCounts}/>
        <OverdueFindingsChartWidget totalCounts={totalCounts} selectedOverdueThreshold={selectedOverdueThreshold}/>
      </div>
    </div>
  );
};

export default Regions;
